import { JOP_POSTINGS_API_URL } from "./constants";

export const getJobPostings = () => fetch(JOP_POSTINGS_API_URL).then((resp) => resp.json());



// WEBPACK FOOTER //
// ./src/apps/careers/util/web.js